import { network } from 'services/network';

export const ENDPOINT = 'api/bo/getLongestAddedActivities';
export const getLongestAddedActivities = (params) => {
    return network.post(ENDPOINT, params).then((response) => {
        return response.data;
    });
};
